module.exports = __webpack_public_path__ + "static/media/badge.563bcc57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/badge.png
// module id = 122
// module chunks = 0